import { useUrlState } from '@village/tools';
import type { FC } from 'react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import * as Styled from './styles';
import { CenteredSpinner } from 'components/centered-spinner';
import { useMessageThread } from 'data/hooks/use-message-thread-query';
import { Countly } from 'modules/countly';
import { MessageList } from 'pages/message-thread/components/message-list';
import type { MessageSource } from 'types';

type ParameterType = 'source' | 'threadId';

const MessageThreadContent: FC = () => {
    const { threadId, source } = useParams<ParameterType>();
    const [origin] = useUrlState('origin');
    const ignoreCache = origin === 'notification';
    const { data, isLoading } = useMessageThread(Number(threadId), (source as MessageSource) ?? '', !!source, ignoreCache);

    useEffect(() => {
        const messagesInThread = data?.results.length;
        if (messagesInThread)
            Countly.addEvent({
                key: 'viewMessage',
                segmentation: {
                    messageThreadId: Number(threadId),
                    messagesInThread,
                    messagingVersion: 2,
                    source: 'messaging',
                },
            });
    }, [data, threadId]);

    if (isLoading) {
        return <CenteredSpinner />;
    }

    if (!data?.results.length) {
        // TODO: Replace this with a proper 404 message component
        return <div data-testid="no-message-thread">No message thread found</div>;
    }

    return (
        <Styled.Container>
            <MessageList messageThread={data.results[0]} />
        </Styled.Container>
    );
};

export { MessageThreadContent };
